import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { BarChart3 } from "lucide-react";
import { CHART, ChartCard, ChartEmpty, Dot, TooltipBox, axisTick, legendContent, formatNumber } from "./ui";

const CustomTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload || payload.length === 0) return null;
  const data = payload[0]?.payload || {};
  return (
    <TooltipBox title={data.dateLabel || label}>
      <span className="flex items-center gap-1.5"><Dot color={CHART.primary} />AI Usage: {formatNumber(data.total_tokens || 0)}</span>
      <span>Questions: {data.total_calls || 0}</span>
    </TooltipBox>
  );
};

const UsageTrendChart = ({ daily }: any) => {
  const card = (body) => (
    <ChartCard icon={<BarChart3 />} title="Daily AI Usage Trend" description="How much AI processing your chatbot used each day.">
      {body}
    </ChartCard>
  );
  if (!daily || daily.length === 0) {
    return card(<ChartEmpty icon={<BarChart3 />} text="No usage data for selected period" />);
  }

  const chartData = daily.map((day) => ({
    ...day,
    dateLabel: day.date
      ? new Date(day.date + "T00:00:00").toLocaleDateString("en-GB", { day: "numeric", month: "short" })
      : "",
  }));

  return card(
    <ResponsiveContainer width="100%" height={280}>
      <BarChart data={chartData} margin={{ top: 10, right: 10, left: 0, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={CHART.grid} vertical={false} />
        <XAxis dataKey="dateLabel" tick={axisTick} tickLine={false} axisLine={{ stroke: CHART.grid }} />
        <YAxis tick={axisTick} tickLine={false} axisLine={false} tickFormatter={formatNumber} />
        <Tooltip content={<CustomTooltip />} cursor={{ fill: "var(--accent)" }} />
        <Legend content={legendContent} />
        <Bar dataKey="total_tokens" name="AI Usage" fill={CHART.primary} radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default UsageTrendChart;
